<template>
  <div class="applicationWrap mainWrap">
    <Table :data="tableData" :options="listDataOptions" align="center">
      <el-table-column slot="operate" min-width="100" label="操作" align="center">
        <template slot-scope="scope">
          <el-button class="operateBtn" v-if="scope.row.isClaim !== '0'" type="text" @click="handlerQRcode(scope.row)">
            理赔
          </el-button>
        </template>
      </el-table-column>
    </Table>
    <Pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :pageData="initParam"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
    />
    <!-- <div class="tips" v-if="tableData && tableData.length"> -->
    <div class="tips" v-if="false">
      还想知道我的个人保单能赔多少？试试保单托管？
      <span class="try" @click="$router.push('/trusteeshipInfo')">点我尝试</span>
    </div>
    <DtPopup :isShow.sync="showQRcode" title="理赔" @close="showQRcode = false" :footer="false">
      <div class="codeWrap" @click.stop>
        <img :src="QRcodeUrl" alt="" @click.stop />
        <p v-if="tipType == 'inner'">扫描二维码穿越到手机<br />申请理赔或追踪理赔进度</p>
        <p v-if="tipType == 'outside'">请您扫描二维码并通过关注 <br />保险公司公众号的方式进行在线理赔</p>
      </div>
    </DtPopup>
  </div>
</template>

<script>
import Table from '@/components/layouts/table';
import Pagination from '@/components/layouts/Pagination';
import DtPopup from '@/components/layouts/DtPopup';
import * as $api from '@/api/claimApplication';
import { myMixin } from '@/mixins';

export default {
  mixins: [myMixin],
  components: {
    Table,
    Pagination,
    DtPopup,
  },
  data() {
    return {
      initParam: { pageNum: 1, pageSize: 10, param: { userId: '' } },
      total: 0,
      tableData: [],
      listDataOptions: [
        { prop: 'policyCode', label: '合同编号', WelfareFlag: true },
        { prop: 'policyName', label: '合同名称' },
        { prop: 'relaWithStaff', label: '与职员关系', dic: 'gcbs.rela.with.staff' },
        { prop: 'productName', label: '保险公司', width: 250 },
        { prop: 'effectiveTime', label: '起始日期' },
        { prop: 'validityTime', label: '结束日期' },
      ],
      showQRcode: false,
      QRcodeUrl: '',
      tipType: 'inner',
    };
  },
  methods: {
    init() {
      this.initParam.param.userId = this.$store.state.user.user.userId;
      this.queryData();
    },
    queryData() {
      $api.claimPolicyPage(this.initParam).then((res) => {
        if (res && res.list) {
          this.tableData = res.list.map((item) => {
            if (item.relaWithStaff !== '01') {
              item.policyName += '（连）';
            }
            return item;
          });
        } else {
          this.tableData = [];
        }
        this.total = res.total;
      });
    },
    handlerQRcode(obj) {
      this.$sa('welfareClaimSettlementElementClick', {
        $element_name: '理赔申请',
      });
      if (obj.isClaim == '1') {
        $api.createQRCode({ userId: this.initParam.param.userId }).then((res) => {
          if (res) {
            this.tipType = 'inner';
            this.showQRcode = true;
            this.QRcodeUrl = res;
          }
        });
      } else {
        $api.claimapplyClaim({ comId: obj.productCode }).then((res) => {
          if (res) {
            // comType: 01 弹二维码 02:跳转链接
            if (res.comType == '01') {
              this.tipType = 'outside';
              this.showQRcode = true;
              this.QRcodeUrl = res.comUrl;
            } else if (res.comType == '02') {
              this.handleJump(res.comUrl);
            }
          }
        });
      }
    },
    handleJump(url) {
      //神策埋点
      this.$sa('welfareClaimSettlementElementClick', {
        $element_name: '理赔申请',
      });
      if (url.includes('http') || url.includes('https')) {
        window.open(url);
      } else {
        window.open(' http://' + url);
      }
    },
  },
};
</script>

<style lang="less">
.applicationWrap {
  .el-table {
    td {
      border-bottom: none;
    }
    .el-radio__input {
      margin-left: 12px;
    }
    .el-radio__label {
      display: none;
    }
    .operateBtn {
      color: #5788bb;
      text-decoration: underline;
    }
  }
}
.tips {
  height: 54px;
  background: rgba(255, 251, 239, 1);
  border: 1px solid rgba(243, 238, 222, 1);
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(85, 85, 90, 1);
  line-height: 54px;
  padding: 0 24px;
  margin: 20px 0;
  .try {
    color: #5788bb;
    text-decoration: underline;
    cursor: pointer;
    text-align: right;
    float: right;
  }
}
.codeWrap {
  text-align: center;
  padding-bottom: 50px;
  img {
    width: 200px;
    height: 200px;
    border: 5px solid #000;
    border-radius: 10px;
    margin: 10px 0;
  }
  p {
    color: #555;
    font-size: 16px;
    line-height: 1.5;
  }
  .claimCardList .claimTitle .iconLian[data-v-d870e762] {
    display: inline-block;
    vertical-align: top;
    margin-left: 1.067vw;
    width: 4.267vw;
    height: 4.267vw;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAGZklEQ…ZyV2ay/dJU1l+boxEoqy9OEgBZf3U2CkKWXp6OnYiz7fr8v+VIg/gO9qg/AAAAAElFTkSuQmCC)
      no-repeat;
    background-size: contain;
  }
}
</style>
